import { SysUserGroup } from './Sysusergroup';

export class Sysuser{
    userid : number;
    usergroupid : number;
    tendangnhap : string;
    matkhau : string;
    hoten : string;
    ngaysinh : Date;
    gioitinh : number;
    diachicanhan : string;
    dienthoaicanhan : string;
    didong : string;
    emailcanhan : string;
    faxcanhan : string;
    tencoquan : string;
    diachicoquan : string;
    dienthoaicoquan : string;
    emailcoquan : string;
    faxcoquan : string;
    ghichu : string;
    sysUserGroup : SysUserGroup;
    retypematkhau : string;
    donviid: number;
    username: string;
    thuocvpub: number;  
}